/**
 * walleu-size-calculator
 * <walleu-size-calculator> — estimates how many panels cover a wall.
 * The panel area (cm²) and the localized result strings come in via data
 * attributes ("[qty]" / "[area]" are replaced client-side), so the element
 * has no globals and supports any locale and multiple instances.
 */
(function () {
  if (window.customElements.get('walleu-size-calculator')) return;

  class WalleuSizeCalculator extends HTMLElement {
    connectedCallback() {
      this.panelArea = parseFloat(this.dataset.panelArea); // cm²
      this.widthInput = this.querySelector('[data-width]');
      this.heightInput = this.querySelector('[data-height]');
      this.resultEl = this.querySelector('[data-result]');

      const locale = (window.Shopify && Shopify.locale) || document.documentElement.lang || 'pt';
      this.areaFormat = new Intl.NumberFormat(locale, { maximumFractionDigits: 2 });

      this.update = this.update.bind(this);
      this.widthInput.addEventListener('input', this.update);
      this.heightInput.addEventListener('input', this.update);
    }

    update() {
      const width = parseFloat(this.widthInput.value);
      const height = parseFloat(this.heightInput.value);

      if (!(width > 0) || !(height > 0) || !(this.panelArea > 0)) {
        this.resultEl.hidden = true;
        return;
      }

      const quantity = Math.max(1, Math.ceil((width * height) / this.panelArea));
      const coveredM2 = (quantity * this.panelArea) / 10000; // cm² → m²
      const template = quantity === 1 ? this.dataset.resultOne : this.dataset.resultOther;

      this.resultEl.textContent =
        template.replace('[qty]', quantity) +
        ' · ' +
        this.dataset.covers.replace('[area]', this.areaFormat.format(coveredM2));
      this.resultEl.hidden = false;
    }
  }

  customElements.define('walleu-size-calculator', WalleuSizeCalculator);
})();
